import apiConfig from './apiConfig';

// Port từ ra-log-monitor-cms/source/src/constants/sitePathConfig.js — CHỈ trang trong phạm vi.
//
// ⚠️ `permissions` là MẢNG THEO CHỈ SỐ: [0] list · [1] getById · [2] create · [3] update · [4] delete
//   Không đổi thứ tự, không thêm bớt phần tử.
//
// 🐞 `logManagement.permissions[3] = 'not_have_update'` — chuỗi GIẢ giữ chỗ, không bao giờ có trong
//    quyền của người dùng. Nút Sửa cần [1] và [3] nên nút Sửa ở /logs LUÔN ẨN (bẫy C2).
//    Giữ nguyên; không port nút đã chết.

export const sitePathConfig = {
    login: {
        path: '/login',
    },
    profile: {
        path: '/profile',
    },
    forbidden: {
        path: '/forbidden',
    },
    admin: {
        path: '/admins',
        permissions: [
            apiConfig.user.getList.permissionCode,
            apiConfig.user.getById.permissionCode,
            apiConfig.user.createAdmin.permissionCode,
            apiConfig.user.updateAdmin.permissionCode,
            apiConfig.user.delete.permissionCode,
        ],
    },
    logManagement: {
        path: '/logs',
        permissions: [
            apiConfig.logs.getList.permissionCode,
            apiConfig.logs.getById.permissionCode,
            apiConfig.logs.create.permissionCode,
            'not_have_update',
            apiConfig.logs.delete.permissionCode,
        ],
    },
};

export default sitePathConfig;
